export default {
    formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import('@/views/form/form-detail.vue')
    },
    application: {
        // 表单中心
        personnelStatistics: {
            path: 'formCenter',
            name: 'form-center',
            component: () => import('./form/start-workflow.vue')
        },
    },
};
